module.exports = __webpack_public_path__ + "b2357da208fbdf98c96d9c7bb3c06ec2.pdf";